import Router from "./renderers/Router"
import Sidebar from "./components/Sidebar/Sidebar"

function App() {
  return (
    <>
      <div className="app">
        <Sidebar />
        <main>
          <Router />
        </main>
      </div>
    </>
  )
}

export default App
